import axios from '../axios'


/* 
 * 人房管理模块
 */
// 查询列表
export const findPage = (data) => {
    return axios({
        url: '/admin/service/sys_carPass_list',
        method: 'post',
        data
    })
}
// 黑名单车辆查询列表
export const blackList_carPass_list = (data) => {
    return axios({
        url: '/admin/service/blackList_carPass_list',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/passCar.js